import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';

/** @deprecated moved to libs folder */
@Component({
    selector: 'ins-panel-expandable',
    template: '<ng-content></ng-content>',
    styleUrls: ['./panel-expandable.component.scss'],
    exportAs: 'panel',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelExpandableComponent implements OnInit, OnChanges {

    @HostBinding('class.panel') panelClass: boolean = true;
    @HostBinding('class.panel--info')
    @Input() hasBorder: boolean = true;
    @Input() id: string;
    @Input() visible: boolean = false;
    @Input() direction: string = 'left';
    @Output() readonly opened: EventEmitter<any> = new EventEmitter();
    @Output() readonly closed: EventEmitter<any> = new EventEmitter();

    @HostBinding('class.hidden') get hidden(): boolean {
        return !this.visible;
    }

    @HostBinding('class.panel--info-left') get isLeft(): boolean {
        return this.direction === 'left';
    }

    @HostBinding('class.panel--info-right') get isRight(): boolean {
        return this.direction === 'right';
    }

    @HostBinding('class.border--none') get border(): boolean {
        return Boolean(this.hasBorder) === false
    }

    @HostBinding('class.panel--info-zelfregelen') get isZelfregelen(): boolean {
        return this.direction === 'zelfregelen';
    }

    ngOnInit(): void {
        if (!this.visible) {
            this.visible = false;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.visible) {
            this.visible = changes.visible.currentValue;
        }
    }

    public toggle(): boolean {
        if (this.visible) {
            return this.close();
        }
        return this.open();
    }

    public open(data?: any): boolean {
        this.visible = true;
        this.opened.emit(data);

        return false;
    }

    public close(): boolean {
        this.visible = false;
        this.closed.emit(null);

        return false;
    }
}
